import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {}

const TrashIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.33331 18C5.87498 18 5.48262 17.8368 5.15623 17.5104C4.82984 17.184 4.66665 16.7917 4.66665 16.3333V5.5H3.83331V3.83333H7.99998V3H13V3.83333H17.1666V5.5H16.3333V16.3333C16.3333 16.7917 16.1701 17.184 15.8437 17.5104C15.5173 17.8368 15.125 18 14.6666 18H6.33331ZM14.6666 5.5H6.33331V16.3333H14.6666V5.5ZM7.99998 14.6667H9.66665V7.16667H7.99998V14.6667ZM11.3333 14.6667H13V7.16667H11.3333V14.6667Z"
        fill="#F04438"
      />
    </svg>
  );
};

export default TrashIcon;
